<template>
  <div class="row" v-if="paymentMethod">
    <div class="col-12 d-flex align-items-center">
      <h2>{{ paymentMethod.name }}</h2>
      <router-link class="btn btn-primary btn-sm ms-3"
                   :to="{name: ROUTES.PAYMENT_METHODS.EDIT, params: {id: paymentMethod.id}}">
        {{ $t('payment_methods.edit') }}
      </router-link>
    </div>

    <div class="col-12 mt-4">
      <div class="card">
        <div class="card-body">
          <show-row :label="$t('payment_methods.id')" :value="String(paymentMethod.id)"/>
          <show-row :label="$t('payment_methods.organization_id')" :value="String(paymentMethod.organization_id)"/>
          <show-row :label="$t('payment_methods.name')" :value="paymentMethod.name"/>
          <show-row :label="$t('payment_methods.key')" :value="paymentMethod.key"/>
          <show-row :label="$t('payment_methods.group')" :value="paymentMethod.group"/>
          <show-row :label="$t('payment_methods.position')" :value="String(paymentMethod.position)"/>
          <show-row :label="$t('payment_methods.notes')" :value="paymentMethod.notes"/>
          <show-row :label="$t('payment_methods.created_at')" :value="formatDate(paymentMethod.created_at, 'datetime') || '-'"/>
          <show-row :label="$t('payment_methods.updated_at')" :value="formatDate(paymentMethod.updated_at, 'datetime') || '-'"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {usePaymentMethodStore} from "@/stores/payment_method";
import {ROUTES} from "@/scripts/constants";
import ShowRow from "@/components/ShowRow.vue";

export default {
  name: 'PaymentMethodsShow',
  components: {
    ShowRow,
  },
  setup() {
    return {
      paymentMethodStore: usePaymentMethodStore(),
    }
  },
  computed: {
    ROUTES() {
      return ROUTES
    },
    paymentMethod() {
      return this.paymentMethodStore.payment_method
    },
  },
  created() {
    this.paymentMethodStore.show(this.$route.params.id).then(() => {
      this.setTitle(this.paymentMethod.name)
    })
  }
}
</script>
